export default __webpack_public_path__ + "static/hochzeitsfotograf-berlin-brandenburg-potsdam-claudia_nuernberger-1e2aa64fecde18e1fd9bd063136b61fb.jpg";